import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-template-email-edit',
  standalone: false,
  templateUrl: './notification-template-email-edit.component.html',
  styleUrl: './notification-template-email-edit.component.scss'
})
export class NotificationTemplateEmailEditComponent {

}
